import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
export function HeroSection() {
  const scrollToOffer = () => {
    document.getElementById('offer')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-gradient-to-b from-[#D8F3DC] to-white py-12 md:py-20" data-id="element-56">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center" data-id="element-58">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D6A4F] mb-6 leading-tight" data-id="element-59">
            Tu primera ensalada en 30 días: Domina el Huerto en Balcón sin morir
            en el intento
          </h1>
          <p className="text-lg md:text-xl text-gray-700 mb-8 max-w-3xl mx-auto" data-id="element-60">
            El sistema exacto para convertir un metro cuadrado de cemento en una
            fuente inagotable de comida fresca, orgánica y libre de precios
            inflados.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="flex justify-center mb-8" data-id="element-61">
          <img src="https://cdn.magicpatterns.com/uploads/5HAaFmwMrmg33tvKYCJdew/portada_landing.png" alt="Maestría en Huerto Urbano" className="max-w-full h-auto rounded-lg shadow-2xl w-full md:w-2/3 lg:w-1/2" data-id="element-62" />
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="flex justify-center" data-id="element-63">
          <Button size="lg" onClick={scrollToOffer} className="bg-[#2D6A4F] hover:bg-[#40916C] text-white text-lg px-8 py-6 rounded-full shadow-lg hover:shadow-xl transition-all" data-id="element-64">
            ¡QUIERO MI COSECHA EN 30 DÍAS!
          </Button>
        </motion.div>
      </div>
    </section>;
}